import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Sparkles, Users, PartyPopper, Plane, Gamepad2, Quote, ArrowRight, Rocket, Camera, X, Images,
} from 'lucide-react';
import './LifeAtSpringup.css';
import { Link } from 'react-router-dom';
import {Celebration1,Celebration2,Celebration3,Celebration4,Celebration5,Celebration6,Celebration7,Celebration8,Celebration9, Celebration15, Celebration17,
    Celebration10,Celebration11,Celebration12,Celebration13,Celebration14 ,Client1,Client2,Client3,Client4,Client5,Client6,Client7,Client8,Client9,Client10,
    FunActivities1,FunActivities2,FunActivities3,FunActivities4, team1,team2,team3 , team4 ,TeamOuting1,TeamOuting2,TeamOuting3,TeamOuting4,
    TeamOuting5,TeamOuting6,TeamOuting7,TeamOuting8 , FunActivities5,FunActivities6,FunActivities7,FunActivities8, ravi, nileshmane, AkshayThakre, ChandradeepBhoite} from '../../../theme/images'
// import mainimg from "../../../assets/lifeatspringuplabs/Celebrations/Celebrations1.jpg"
const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1, y: 0,
    transition: { delay: i * 0.08, duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] },
  }),
};

const sections = [
  {
    id: 'client-visits',
    eyebrow: 'Client Visits',
    icon: Users,
    title: 'Building bridges with our',
    accent: 'global clients',
    description:
      'From boardrooms to brainstorms — we host clients from across the world for working sessions, design sprints and warm cultural welcomes.',
    highlights: ['Executive workshops', 'Onsite immersions', 'Cross-cultural exchange', 'Strategic roadmapping'],
    images: [
      { src: Client5, cap: 'Strategy session' },
      { src: Client9, cap: 'Client Welcome' },
      { src: Client10, cap: 'Client workshop' },
    ],
    gallery: [
      { src: Client1, cap: 'Welcome dinner' },
      { src: Client2, cap: 'Client workshop' },
      { src: Client3, cap: 'Cultural welcome' },
      { src: Client4, cap: 'Opening ceremony' },
      { src: Client5, cap: 'Team intro' },
      { src: Client6, cap: 'Team Photo' }, 
      { src: Client7, cap: 'Welcome ' },
      { src: Client8, cap: 'Cultural welcome' },
      { src: Client9, cap: 'Cultural welcome' },
      { src: Client10, cap: 'Workshop wrap-up' },
      // { src: Client11, cap: 'Cultural welcome' },
    ],
  },
  {
    id: 'team-outing',
    eyebrow: 'Team Outing',
    icon: Plane,
    title: 'Adventures that bring our',
    accent: 'teams closer',
    description:
      'Mountains, beaches, road trips and resort retreats — we step out of the office to recharge, reconnect and create memories that last.',
    highlights: ['Annual offsites', 'Adventure trails', 'Nature retreats', 'Beach getaways'],
    images: [
      { src:  TeamOuting7, cap: 'Mountain trek' },
      { src: TeamOuting8, cap: 'Hillside retreat' },
      { src: team3, cap: 'Annual offsites' },
    ],
    gallery: [
      { src: TeamOuting1, cap: 'Mountain trek' },
      { src: TeamOuting2, cap: 'Adventure squad' },
      { src: TeamOuting3, cap: 'Resort offsite' },
      { src: TeamOuting4, cap: 'Mountain trek' },
      { src: TeamOuting5, cap: 'Road trip' },
      { src: TeamOuting6, cap: 'Hillside retreat' },
      { src: TeamOuting7, cap: 'Waterfall trek' },
      { src: TeamOuting8, cap: 'Adventure squad' },
    ],
  },
  {
    id: 'celebration',
    eyebrow: 'Celebrations',
    icon: PartyPopper,
    title: 'Festivals, milestones &',
    accent: 'moments of joy',
    description:
      'Diwali lights, secret-santas, anniversaries and birthdays — we celebrate every reason, big or small, with the whole Springup family.',
    highlights: ['Festive parties', 'Work anniversaries', 'Project go-lives', 'Award nights'],
    images: [
      { src: Celebration15, cap: 'Anniversary party' },
      { src: Celebration1, cap: 'festive Celebration' },
      { src: team2, cap: 'Team celebration' },
    ],
    gallery: [
      { src: Celebration2, cap: 'Festival lights' },
      { src: Celebration3, cap: 'Annual gala' },
      { src: Celebration4, cap: 'Diwali party' },
      { src: Celebration5, cap: 'Anniversary party' },
      { src: Celebration6, cap: 'Cake Cutting' },
      { src: Celebration7, cap: 'Dasara Celebration' },
      { src: Celebration8, cap: 'Anniversary toast' },
      { src: Celebration10, cap: 'Anniversary Celebration' },
      { src: Celebration11, cap: 'Team Party' },
      { src: Celebration12, cap: '15th August celebration' },
      { src: Celebration13, cap: '26th January celebration' },
      { src: Celebration14, cap: 'Diwali Gifts' },
    ],
  },
  {
    id: 'fun-activities',
    eyebrow: 'Fun Activities',
    icon: Gamepad2,
    title: 'Where work meets',
    accent: 'play every week',
    description:
      'Friday game nights, foosball wars, art jams and quiz battles — there is always something fun happening around the Springup floor.',
    highlights: ['Game nights', 'Quiz & trivia', 'Sports leagues', 'Creative jams'],
    images: [
      { src: FunActivities5, cap: 'Art & jam' },
      { src: FunActivities3, cap: 'Friday game' },
      { src: FunActivities7, cap: 'Art & jam' },
    ],
    gallery: [
      { src: FunActivities1, cap: 'Friday game' },
      { src: FunActivities2, cap: 'Fun Friday' },
      { src: FunActivities3, cap: 'Games ' },
      { src: FunActivities4, cap: 'Fun Friday' },
      { src: FunActivities5, cap: 'Art & jam' },
      { src: FunActivities6, cap: 'Art & jam' },
      { src: FunActivities7, cap: 'Art & jam' },
      { src: FunActivities8, cap: 'Art & jam' },
    ],
  },
];

const quotes = [
  {
    text: "Over the past two years at SpringUp, I've had the opportunity to work on modern DevOps practices, automate deployment pipelines, and improve infrastructure reliability. The trust and support from the team have helped me grow both technically and professionally.",
    name: "Ravi Pawar",
    role: "Senior DevOps Engineer",
    img: ravi,
  },
  {
    text: "During my three years at SpringUp, I've worked on cloud-native solutions, CI/CD automation, and scalable infrastructure for diverse client projects. Every project has strengthened my technical expertise and confidence.",
    name: "Nilesh Mane",
    role: "Cloud/DevOps Engineer",
    img: nileshmane,
  },
  {
    text: "For the last three years, SpringUp has provided me with opportunities to design scalable backend systems, solve complex engineering challenges, and collaborate with an amazing team. It's been an incredible journey of continuous learning and growth.",
    name: "Akshay Thakare",
    role: "Senior Backend Developer",
    img: AkshayThakre,
  },
  {
  text: "My three-year journey at SpringUp has been an incredible experience. Working as a Frontend Developer has helped me grow technically, take on new challenges, and continuously improve. The team's culture of learning, collaboration, and innovation has played a major role in shaping my career.",
  name: "Chandradeep Bhoite",
  role: "Frontend Developer",
  img: ChandradeepBhoite
}
];

const LifeAtSpringup = () => {
  const [openSection, setOpenSection] = useState(null);
  const [lightbox, setLightbox] = useState(null);

  const closeAll = () => {
    setLightbox(null);
    setOpenSection(null);
  };

  return (
    <div className="las-page">
      {/* HERO */}
      <section className="las-hero">
        <div className="las-hero__dots" />
        <div className="las-hero__blob las-hero__blob--a" />
        <div className="las-hero__blob las-hero__blob--b" />
        <div className="las-container  container">
          <div className="las-hero__inner">
            <motion.span className="las-eyebrow" initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
              <Sparkles size={14} /> Life at Springup
            </motion.span>
            <motion.h1 className="las-hero__title" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
              Where great work meets <span className="las-hero__accent">unforgettable moments</span>
            </motion.h1>
            <motion.p className="las-hero__sub" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
              Step inside our world of client journeys, team adventures, celebrations and pure fun —
              the things that make Springup, Springup.
            </motion.p>
            <motion.div className="las-hero__chips" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
              {sections.map((s) => (
                <a key={s.id} href={`#${s.id}`} className="las-hero__chip">
                  <s.icon size={14} /> {s.eyebrow}
                </a>
              ))}
            </motion.div>
          </div>
          <motion.div className="las-collage" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35, duration: 0.7 }}>
            <div className="las-collage__item las-collage__item--a">
              <img src={team1}alt="" />
            </div>
            <div className="las-collage__item las-collage__item--b">
              <img src={Celebration17} alt="" />
            </div>
            <div className="las-collage__item las-collage__item--c">
              <img src={Celebration9} alt="" />
            </div>
            <div className="las-collage__item las-collage__item--d">
              <img src={team3} alt="" />
            </div>
            <div className="las-collage__item las-collage__item--b">
              <img src={team4} alt="" />
            </div>
            <div className="las-collage__item las-collage__item--d">
              <img src={Celebration12} alt="" />
            </div>
          </motion.div>
        </div>
      </section>

      {/* DYNAMIC SECTIONS */}
      {sections.map((s, idx) => {
        const reverse = idx % 2 === 1;
        const hasMore = s.gallery.length > s.images.length;
        return (
          <section key={s.id} id={s.id} className={`las-block ${reverse ? 'las-block--reverse' : ''} ${idx % 2 === 1 ? 'las-block--alt' : ''}`}>
            <div className="las-container las-block__inner  container">
              <motion.div className="las-block__copy" initial={{ opacity: 0, x: reverse ? 40 : -40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: '-80px' }} transition={{ duration: 0.6 }}>
                <div className="las-block__index">0{idx + 1}</div>
                <span className="las-eyebrow"><s.icon size={14} /> {s.eyebrow}</span>
                <h2 className="las-block__title">
                  {s.title} <span className="las-block__accent">{s.accent}</span>
                </h2>
                <p className="las-block__desc">{s.description}</p>
                <ul className="las-block__list">
                  {s.highlights.map((h) => (
                    <li key={h}><span className="las-block__tick" />{h}</li>
                  ))}
                </ul>
                {hasMore && (
                  <button type="button" className="las-block__more" onClick={() => setOpenSection(s)}>
                    <Images size={16} /> See more images
                    <span className="las-block__more-count">{s.gallery.length}</span>
                  </button>
                )}
              </motion.div>

              <motion.div className="las-block__media" initial={{ opacity: 0, x: reverse ? -40 : 40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: '-80px' }} transition={{ duration: 0.6 }}>
                <div className="las-block__stack">
                  {s.images.map((img, i) => (
                    <div key={i} className={`las-block__img las-block__img--${i}`}>
                      <img src={img.src} alt={img.cap} loading="lazy" />
                      <span className="las-block__cap"><Camera size={12} /> {img.cap}</span>
                    </div>
                  ))}
                  <div className="las-block__ring" />
                </div>
              </motion.div>
            </div>
          </section>
        );
      })}

      {/* QUOTES */}
      <section className="las-section las-section--alt">
        <div className="las-container  container">
          <motion.div className="las-section__head" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} custom={0}>
            <span className="las-eyebrow"><Quote size={14} /> Voices</span>
            <h2 className="las-section__title">Stories From Our Team</h2>
          </motion.div>
          <div className="las-quotes">
            {quotes.map((q, i) => (
              <motion.div key={q.name} className="las-quote" custom={i} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <div className="las-quote__mark"><Quote /></div>
                <p>"{q.text}"</p>
                <div className="las-quote__person">
                  <img src={q.img} alt={q.name} />
                  <div>
                    <strong>{q.name}</strong>
                    <span>{q.role}</span>
                  </div>
                </div> 
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="las-cta">
        <div className="las-container las-cta__inner">
          <motion.span className="las-eyebrow" initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <Rocket size={14} /> Join Us
          </motion.span>
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}>
            Ready to write your next chapter with us?
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
            Explore open roles across engineering, design, cloud, AI and consulting — and find the team that fits you.
          </motion.p>
          <motion.a className="las-cta__btn"  initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}>
            <Link to="/careers" className='text-white text-decoration-none'>See open positions <ArrowRight size={18} /></Link>
          </motion.a>
        </div>
      </section>

      {/* GALLERY MODAL */}
      <AnimatePresence>
        {openSection && (
          <motion.div
            className="las-modal"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={closeAll}
          >
            <motion.div
              className="las-modal__panel"
              initial={{ y: 30, opacity: 0, scale: 0.98 }}
              animate={{ y: 0, opacity: 1, scale: 1 }}
              exit={{ y: 20, opacity: 0, scale: 0.98 }}
              transition={{ duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="las-modal__head">
                <div>
                  <span className="las-eyebrow"><openSection.icon size={14} /> {openSection.eyebrow}</span>
                  <h3 className="las-modal__title">
                    {openSection.title} <span className="las-block__accent">{openSection.accent}</span>
                  </h3>
                </div>
                <button className="las-modal__close" onClick={closeAll} aria-label="Close gallery">
                  <X size={20} />
                </button>
              </div>
              <div className="las-modal__grid">
                {openSection.gallery.map((img, i) => (
                  <motion.button
                    type="button"
                    key={i}
                    className="las-modal__tile"
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.04, duration: 0.4 }}
                    onClick={() => setLightbox(img)}
                  >
                    <img src={img.src} alt={img.cap} loading="lazy" />
                    <span className="las-modal__cap"><Camera size={12} /> {img.cap}</span>
                  </motion.button>
                ))}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* LIGHTBOX */}
      <AnimatePresence>
        {lightbox && (
          <motion.div
            className="las-lightbox"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setLightbox(null)}
          >
            <button className="las-modal__close las-lightbox__close" onClick={() => setLightbox(null)} aria-label="Close image">
              <X size={22} />
            </button>
            <motion.img
              src={lightbox.src}
              alt={lightbox.cap}
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            />
            <span className="las-lightbox__cap">{lightbox.cap}</span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LifeAtSpringup;